import { errorSelector } from '../../modules/LoadingStatus';
import { connect } from 'react-redux';
import SuccessPage from '../../components/SuccessPage/SuccessPage';
import { resetToDashboard } from '../../modules/Navigation';
import {eSimSelectedSelector} from '../../modules/ESim/selectors';
import {installESim, eSimSelectedSuccess} from '../../modules/ESim/actions';

import type { StateProps, DispatchProps } from '../../components/SuccessPage/SuccessPage';
import type { StateType } from '../../modules/reducers';

const mapStateToProps = (state: StateType): StateProps => ({
  error: errorSelector(state, 'suspendSwapTerminateLine'),
  eSimSelected: eSimSelectedSelector(state),
});

const mapDispatchToProps = dispatch => ({
  confirmButtonAction: () => resetToDashboard(),
  installESimAction: () => dispatch(installESim()),
  selectEsim: (value: Boolean) => dispatch(eSimSelectedSuccess(value)),
});

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPage);
